import { axios } from "../config";

function loginUser(data) {
  return axios.post("api/v1/users/signin", data);
}

function notificationsSubscribe(data) {
  return axios.post("api/v1/notifications/subscribe", data);
}

function logoutUser(data) {
  return axios.post("api/v1/users/signout", data);
};

function forgotPassword(data) {
  return axios.post("api/v1/users/forgot-password", data);
};

function resetPassword(data) {
  return axios.post("api/v1/users/reset-password", data);
};

function changePassword(data) {
  return axios.post("api/v1/users/change-password", data);
};

export { 
  loginUser, 
  notificationsSubscribe, 
  logoutUser, 
  forgotPassword,
  resetPassword,
  changePassword
};
